document.addEventListener('DOMContentLoaded', function () {
  $(document).on('click', '[data-clickable]', function (event) {
    const $container = $(event.currentTarget)
    const $target = $(event.target)

    const isChildOfLink = $target.parentsUntil($container).filter('a').length > 0
    const isLink = $(event.target).is('a') || $(event.target).data('no-follow')

    // when clicked on a link, or an element inside of a link — ignore
    if (isLink || isChildOfLink) return

    const link = $(this).data('clickable')
    window.location.href = link
  })
})

const defaultOptions = {
  heading: {
    options: [
      { model: 'paragraph', title: 'Paragraph', class: 'ck-heading_paragraph' },
      { model: 'heading1', view: 'h2', title: 'H2', class: 'ck-heading_heading1' },
      { model: 'heading2', view: 'h3', title: 'H3', class: 'ck-heading_heading2' },
      { model: 'heading3', view: 'h4', title: 'H4', class: 'ck-heading_heading3' },
    ],
  },
}

window.initCKEditor = initCKEditor
export function initCKEditor(el, options = defaultOptions) {
  Object.assign(options, {
    cloudServices: {
      tokenUrl: '/admin/blog/token',
      uploadUrl: 'https://40209.cke-cs.com/easyimage/upload/',
    },
    link: {
      decorators: [
        {
          mode: 'manual',
          label: 'Nofollow',
          attributes: {
            target: '_blank',
            rel: 'nofollow noopener noreferrer',
          },
        },
      ],
    },
  })

  if (!window.ClassicEditor) {
    console.warn('ClassicEditor not loaded. Set CK_EDITOR_CDN_URL env variable.')
    return Promise.resolve(null)
  }

  return window.ClassicEditor.create(el, options)
}
